import React, { useEffect, useMemo, useState } from "react";
import Header from "../../../../Components/Header";
import SingleSignOnSideBar from "../../../../Components/SingleSignOnSideBar";
import performanceReportnavigate from "../../../../asset/images/ibaimages/performanceReportNavigate.svg";
import { HighchartsReact } from "highcharts-react-official";
import Highcharts from "highcharts";
import { IBA_Admin_Section } from "../../../../Configuration/API_URL";
import { Button, Modal } from "react-bootstrap";
import IBADuration from "../../../IBAAdmin/IBADuration";
import moment from "moment";
import backDetails from '../../../../asset/images/ibaimages/backDetails.svg';
import { useLocation, useNavigate } from "react-router-dom";
import SmallLoader from "../../../../Components/Common/smallLoader";
import { toast } from "react-toastify";
import ibadown from '../../../../asset/images/ibaimages/iba-down.svg';
import { axiosInstance0 } from "../../../../CommonMethhods/axiosInstance";


const getDateRangeByDuration = (val) => {
  let firstDay = "";
  let lastDay = "";

  if (val === "today") {
    firstDay = moment().format("MM-DD-YYYY");
    lastDay = moment().format("MM-DD-YYYY");
  }
  else if (val === "yesterday") {
    firstDay = moment().subtract(1, "day").format("MM-DD-YYYY");
    lastDay = moment().subtract(1, "day").format("MM-DD-YYYY");
  }
  else if (val === "this_week") {
    firstDay = moment()
      .startOf("week")
      .add(1, "day") // Monday
      .format("MM-DD-YYYY");
    lastDay = moment().format("MM-DD-YYYY");
  }
  else if (val === "last_week") {
    firstDay = moment()
      .subtract(1, "week")
      .startOf("week")
      .add(1, "day")
      .format("MM-DD-YYYY");
    lastDay = moment()
      .subtract(1, "week")
      .endOf("week")
      .add(1, "day")
      .format("MM-DD-YYYY");
  }
  else if (val === "this_month") {
    firstDay = moment().startOf("month").format("MM-DD-YYYY");
    lastDay = moment().format("MM-DD-YYYY");
  }
  else if (val === "last_month") {
    firstDay = moment()
      .subtract(1, "month")
      .startOf("month")
      .format("MM-DD-YYYY");
    lastDay = moment()
      .subtract(1, "month")
      .endOf("month")
      .format("MM-DD-YYYY");
  }
  else if (val === "till_date") {
    firstDay = moment("2000-01-01").format("MM-DD-YYYY");
    lastDay = moment().format("MM-DD-YYYY");
  }

  return { firstDay, lastDay };
};

const IbaPerformanceReports = () => {
  const userId = localStorage.getItem("userId");
  const userName = localStorage.getItem("userNameIBA");
  const navigate = useNavigate();
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [agentDetails, setAgentDetails] = useState({})
  const [selectDuration, setSelectDuration] = useState("yesterday");
  const location = useLocation();
  const [csvLoader, setCsvLoader] = useState(false);
  const [submitLoader, setSubmitLoader] = useState(false);
  const [text, setText] = useState("");

  const selectedAgent = location?.state?.agent;

   useEffect(() => {
    if (selectedAgent?.sapCode) {
      localStorage.removeItem("sapCode");
      localStorage.setItem("sapCode", selectedAgent?.sapCode);
    }

    if(selectedAgent?.agentName){
      localStorage.removeItem("userNameIBA");
      localStorage.setItem("userNameIBA", selectedAgent?.agentName);

    }
  }, [selectedAgent?.sapCode, selectedAgent?.agentName]);


  useEffect(() => {
    const { firstDay, lastDay } = getDateRangeByDuration(selectDuration);
    setFromDate(firstDay);
    setToDate(lastDay);
  }, []);

  const getCardDetails = async () => {
    const payload = {
      agentId: selectedAgent?.sapCode,
      agentName: selectedAgent?.agentName,
      from_date: fromDate,
      to_date: toDate
    }
    try {
      const response = await axiosInstance0.post(
        IBA_Admin_Section.agentPerformanceData,
        payload,

      );
      const data = await response.data;
      if (data.status === 0) {
        setAgentDetails(data.data);
      } else {
        setAgentDetails({});
      }
    } catch (err) {
      console.log(err);
      setAgentDetails({});
    }
  };

  useEffect(() => {
    if (fromDate && toDate) {
      getCardDetails();
    }
  }, [fromDate, toDate]);

  const disposition = agentDetails?.dispositionDetails || {};

  const totalLeads = disposition?.totalLeads || 0;
  const validLeads = disposition?.validLeads || 0;
  const invalidLeads = disposition?.invalidLeads || 0;

  const donutData = useMemo(() => {
    if (!totalLeads) return [];

    return [
      {
        name: "Valid Leads",
        y: Number(((validLeads / totalLeads) * 100).toFixed(1)),
      },
      {
        name: "Invalid Leads",
        y: Number(((invalidLeads / totalLeads) * 100).toFixed(1)),
      },
    ];
  }, [totalLeads, validLeads, invalidLeads]);

  const dispositionScore = useMemo(() => {
    if (!totalLeads) return 0;
    return Math.round((validLeads / totalLeads) * 100);
  }, [totalLeads, validLeads]);


  const Donut = {
    credits: {
      enabled: false,
    },
    chart: {
      plotBackgroundColor: null,
      plotBorderWidth: 0,
      plotShadow: false,
      height: 175,
      width: 285,
      // plotAreaWidth: 250,
      // plotAreaHeight: 150,
    },
    title: {
      text: `${dispositionScore}`,
      align: "center",
      verticalAlign: "middle",
      y: 26, // for title top margin
      style: {
        fontSize: "30px",
        fontWeight: "500",
        color: "#000000",
      },
    },
    tooltip: {
      enabled: false,
    },

    accessibility: {
      point: {
        valueSuffix: "%",
      },
    },
    plotOptions: {
      pie: {
        point: {
          events: {
            // click: function () {
            //   handleSectorClick();
            // },
          },
        },
        dataLabels: {
          enabled: false, // to hide labels
          style: {
            fontWeight: "bold",
            color: "white",
          },
        },
      },
    },
    series: [
      {
        name: "Disposition",
        type: "pie",
        size: "100%",
        innerSize: "75%",
        data: donutData,
      },
    ],

    colors: ["#64E169", "#DFF6DD"],
  };

  const callQualityScore =
    Number(agentDetails?.talktimeDetails?.callQualityScore) || 0;

  const callQualityData = [
    {
      name: "Score",
      y: callQualityScore,
    },
    {
      name: "Remaining",
      y: 100 - callQualityScore,
    },
  ];

  const DonutCall = {
    credits: {
      enabled: false,
    },
    chart: {
      plotBackgroundColor: null,
      plotBorderWidth: 0,
      plotShadow: false,
      height: 175,
      width: 285,
      // plotAreaWidth: 100,
      // plotAreaHeight: 150,
    },
    title: {
      text: `${callQualityScore}`,
      align: "center",
      verticalAlign: "middle",
      y: 26,
      style: {
        fontSize: "30px",
        fontWeight: "500",
        color: "#000000",
      },
    },
    tooltip: {
      enabled: false,
      // pointFormat: `{series.name}: <b>{point.percentage:.1f}%</b>`,
    },

    accessibility: {
      point: {
        valueSuffix: "%",
      },
    },
    plotOptions: {
      pie: {
        point: {
          events: {
            // click: function () {
            //   handleSectorClick();
            // },
          },
        },
        dataLabels: {
          enabled: false, // to hide labels
          style: {
            fontWeight: "bold",
            color: "white",
          },
        },
      },
    },
    series: [
      {
        name: "Disposition",
        type: "pie",
        size: "100%",
        innerSize: "75%",
        data: callQualityData,
      },
    ],

    colors: ["#1C74D0", "#1C74D033"],
  };

  const backNavigate = () => {
    navigate("/iba-agentDetails")
  }

  const handlePerformance = (agentData) => {
    navigate("/personal-insight", {
      state: {
        agent: agentData,
      },
    });
  };

  const addFeedbackData = async () => {
    setSubmitLoader(true);
    const payload = {
      feedback: text,
      agentId: userId,
      agentName: userName !== null ? userName : selectedAgent?.agentName
    }
    try {
      const response = await axiosInstance0.post(
        IBA_Admin_Section.Feedback_Input,
        payload,

      );
      const resVal = response?.data;
      if (resVal?.status === 0) {
        getCardDetails()
        setText("")
        toast.success(resVal?.data)
      } else {
        toast.error(resVal?.message);
      }
    } catch (error) {
      console.error("Error", error);
    }
    finally {
      setSubmitLoader(false);
    }
  };

  const handleFeedback = () => {
    addFeedbackData();
  }

  const handlePasteInput = () => (e) => {
        e.preventDefault();
        const pastedText = e.clipboardData.getData("text");

        let clean = pastedText.replace(/[^A-Za-z0-9\s]/g, "")
        clean = clean.replace(/\s+/g, " ").trim();
        if (clean === "") return;

        const input = e.target;
        const start = input.selectionStart;
        const end = input.selectionEnd;
        const currentValue = input.value;

        const newValue = (
            currentValue.slice(0, start) +
            clean +
            currentValue.slice(end)
        ).slice(0, 1000);
        setText(newValue)
        
        input.value = newValue;
        const cursorPos = start + clean.length;
        setTimeout(() => input.setSelectionRange(cursorPos, cursorPos), 0);
    };

    const formatDate = (dateString) => {
  if (!dateString) return "";

  const date = new Date(dateString);

  const day = String(date.getDate()).padStart(2, "0");
  const month = date.toLocaleString("en-GB", { month: "short" }).toUpperCase();
  const year = date.getFullYear();

  return `${day} ${month} ${year}`;
};

  return (
    <div>
      <Header portal={"IBA"} />
      <SingleSignOnSideBar />
      <main id="main-content" className="telecallerDash">
        <div className='card-box iba-page'>
          <div className="agent-table-wrapper">
            <div className='main-header-title'>
              <div className="wrap-header report-head">
                <img style={{ cursor: "pointer" }} src={backDetails} alt="backDetails" onClick={() => backNavigate()} />
                <div className='module-title'>{selectedAgent?.agentName || userName}</div>
              </div>

              <IBADuration
                setFromDate={setFromDate}
                setToDate={setToDate}
                setSelectDuration={setSelectDuration}
                selectDuration={selectDuration}
                label="iba-performance"
              />
            </div>
          </div>
          <div className="personal-card agent-payout-new per-graph">
            <div className="personal-details-card position-relative">
              <img
                src={performanceReportnavigate}
                alt="report navigate"
                style={{
                  position: "absolute",
                  top: 6,
                  right: 0,
                  width: "53px",
                  height: "40px",
                  cursor: "pointer"
                }}
                onClick={() => handlePerformance(selectedAgent)}
              />

              <span className="iba-card-title mb-2">Accounts Opened</span>
              <p className="mb-5 report-count">{agentDetails?.accountsDetails?.accountsOpened || "0"}</p>
              <div style={{ fontSize: "14px" }}>
                <div className="d-flex justify-content-between mb-1">
                  <span className="text-muted">Accounts Submitted:</span>
                  <span className="total-numbers">{agentDetails?.accountsDetails?.accountsSubmitted || "0"}</span>
                </div>
                <div className="d-flex justify-content-between">
                  <span className="text-muted ">Accounts Rejected:</span>
                  <span className="total-numbers">{agentDetails?.accountsDetails?.accountsRejected || "0"}</span>
                </div>
              </div>
            </div>
            <div className="personal-details-card position-relative">
              {/* <img
                src={performanceReportnavigate}
                alt="report navigate"
                style={{
                  position: "absolute",
                  top: 6,
                  right: 0,
                  width: "53px",
                  height: "40px",
                }}
              /> */}
              <span className="iba-card-title mb-2">Talk Time</span>
              <span className="wrap-number"><p className="report-count">{agentDetails?.talktimeDetails?.total_talk_time || "0.00"}</p> Mins</span>
              <div style={{ fontSize: "14px" }}>
                <div className="d-flex justify-content-between mb-1">
                  <span className="text-muted ">Average Talktime:</span>
                  <span className="total-numbers"><span>{agentDetails?.talktimeDetails?.average_talk_time || "0.00"}</span> Mins</span>

                </div>
                <div className="d-flex justify-content-between mb-1">
                  <span className="text-muted  ">Total Present Days:</span>
                  <span className="total-numbers"><span>{agentDetails?.talktimeDetails?.totalPresentDay || "0"}</span> Days</span>
                </div>
                <div className="d-flex justify-content-between">
                  <span className="text-muted ">Total Absent Days</span>
                  <span className="total-numbers"><span>{agentDetails?.talktimeDetails?.totalAbsentDay || "0"}</span> Days</span>
                </div>
              </div>
            </div>
          </div>

          <div className="personal-card agent-payout-new per-graph">
            <div className="personal-details-card position-relative">

              <span className="iba-card-title mb-2">Disposition Score</span>
              {/* <p className="mb-5 report-count">2400</p> */}
              <div className="wrap-graph">
                <div style={{ fontSize: "14px", width: "55%" }} className="mt-5">
                  <div className="d-flex justify-content-between mb-1 report-sec">
                    <span className="text-muted ">TOTAL LEADS:</span>
                    <span className="total-numbers">{agentDetails?.dispositionDetails?.totalLeads || "0"}</span>
                  </div>
                  <div className="d-flex justify-content-between report-sec">
                    <span className="text-muted ">TOTAL VALID:</span>
                    <span className="total-numbers">{agentDetails?.dispositionDetails?.validLeads || "0"}</span>
                  </div>
                  <div className="d-flex justify-content-between report-sec">
                    <span className="text-muted ">TOTAL INVALID:</span>
                    <span className="total-numbers">{agentDetails?.dispositionDetails?.invalidLeads || "0"}</span>
                  </div>
                </div>

                <div className="chart-donut">
                  <HighchartsReact highcharts={Highcharts} options={Donut} />
                </div>
              </div>
              {/* <button className="hold-payout-btn download-btn" onClick={handleDownload}>
                {csvLoader ?
                  <SmallLoader />
                  : <>
                    <img src={ibadown} alt="" width={"12px"} height={"12px"} /> Download Report
                  </>}

              </button> */}
            </div>

            <div className="personal-details-card position-relative">
              {/* <img
                src={performanceReportnavigate}
                alt="report navigate"
                style={{
                  position: "absolute",
                  top: 6,
                  right: 0,
                  width: "53px",
                  height: "40px",
                }}
              /> */}
              <span className="iba-card-title mb-2">Call Quality</span>
              <div className="wrap-graph-call">
                <p className="mb-5 report-count">Excellent</p>

                <div className="chart-donut">
                  <HighchartsReact highcharts={Highcharts} options={DonutCall} />
                </div>
              </div>
            </div>
          </div>

          <div className="feedback-card">
            <div className="feedback-details-card">
              <span className="iba-card-title">IMPROVEMENT FEEDBACK</span>
              <div className="feedback-input-card">
                <textarea
                  value={agentDetails?.agentFeedbackDetails?.Feedback}
                  maxLength={1000}
                  onChange={(e) => setText(e.target.value)}
                  className="feedback-input"
                  onInput={(e) => {
                    const start = e.target.selectionStart;
                    const end = e.target.selectionEnd;
                    let input = e.target.value;
                    input = input
                        .replace(/[^A-Za-z0-9\s]/g, "")
                        .replace(/\s+/g, " ")
                        .trimStart()
                        .slice(0, 1000);
                    e.target.value = input;
                    e.target.setSelectionRange(start, end);
                    }}
                  disabled={agentDetails?.agentFeedbackDetails?.Feedback}
                  onPaste={handlePasteInput}
                />

              <div className="feedback-time">{agentDetails?.agentFeedbackDetails?.FeedbackDate}</div>
                
              </div>
              <div className="wrap-iba-btn">
              <button 
                className={`approve-btn mr-3 mt-3 ${text?.length === 0 ? "disable-iba-btn" : ""}`}
                type="button"
                disabled={text?.length === 0}
                  onClick={() => handleFeedback()}
                >
                  {submitLoader ?
                    <SmallLoader />
                    : <>SUBMIT</>
                    }

                </button>
                </div>

            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default IbaPerformanceReports;
